import dayjs from 'dayjs';

export const convertFilters = ({ from, to }) => ({
  date_from: dayjs(from).add(-1, 'hour').format('YYYY-MM-DD HH:mm'),
  date_to: dayjs(to).add(-1, 'hour').add(-1, 'millisecond').format('YYYY-MM-DD HH:mm:ss.SSS'),
});
